import { lazy } from 'react';
import { parsePath } from '../services/language';

// Страница в отдельном чанке. preload() загружает чанк заранее: после этого страница рисуется сразу,
// без Suspense. Это важно для первого рендера поверх пререндера — fallback стёр бы готовый контент.
const lazyPage = load => {
  let Loaded = null;
  const preload = () =>
    load().then(module => {
      Loaded = module.default;
      return module;
    });
  const LazyComponent = lazy(preload);
  const Page = props => (Loaded ? <Loaded {...props} /> : <LazyComponent {...props} />);
  Page.preload = preload;
  return Page;
};

export const TablesPage = lazyPage(() => import('./TablesPage.js'));
export const Table1 = lazyPage(() => import('../components/Table1'));
export const Table2 = lazyPage(() => import('../components/Table2'));
export const Table3 = lazyPage(() => import('../components/Table3'));
export const Table4 = lazyPage(() => import('../components/Table4'));
export const Table5 = lazyPage(() => import('../components/Table5'));
export const ComparePage = lazyPage(() => import('./ComparePage'));
export const CalculatorPage = lazyPage(() => import('./CalculatorPage'));
export const CalculatorModal = lazyPage(() => import('../components/CalculatorModal'));
export const SettingsPage = lazyPage(() => import('./SettingsPage'));
export const LanguageSelectPage = lazyPage(() => import('./LanguageSelectPage'));
export const PrivacyPolicyPage = lazyPage(() => import('./PrivacyPolicyPage.js'));
export const PrivacyPolicyIosPage = lazyPage(() => import('./PrivacyPolicyIosPage.js'));

// Чанк страницы текущего адреса (rest — путь без языка: '/tables/table-1')
const routes = [
  [/^\/tables\/?$/, TablesPage],
  [/^\/tables\/table-1/, Table1],
  [/^\/tables\/table-2/, Table2],
  [/^\/tables\/table-3/, Table3],
  [/^\/tables\/table-4/, Table4],
  [/^\/tables\/table-5/, Table5],
  [/^\/element\/\d+\/compare\/?$/, ComparePage],
  [/^\/calculators\/?$/, CalculatorPage],
  [/^\/calculators\/calculator-/, CalculatorModal],
  [/^\/settings\/?$/, SettingsPage],
  [/^\/settings\/language\/?$/, LanguageSelectPage]
];

export const preloadPageForPath = pathname => {
  if (pathname === '/privacy-policy') {
    return PrivacyPolicyPage.preload();
  }
  if (pathname === '/privacy-policy-ios') {
    return PrivacyPolicyIosPage.preload();
  }
  const { rest } = parsePath(pathname);
  return routes.find(([pattern]) => pattern.test(rest))?.[1].preload();
};
